import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { getNestedValue } from '../utils';
/**
 * The default row component of the TreeList.
 */
export var TreeListRow = React.forwardRef(function (props, ref) {
    var selectedField = props.selectedField, dataItem = props.dataItem, rowHeight = props.rowHeight, isAltRow = props.isAltRow;
    var selected = Boolean(selectedField !== undefined && getNestedValue(selectedField, dataItem));
    var className = classNames('k-master-row', {
        'k-state-selected': selected,
        'k-alt': isAltRow
    });
    var style = React.useMemo(function () { return rowHeight !== undefined ? { height: rowHeight + 'px' } : undefined; }, [rowHeight]);
    var defaultRendering = (React.createElement("tr", { onClick: props.onClick, className: className, style: style, ref: ref }, props.children));
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
});
//# sourceMappingURL=TreeListRow.js.map